module.exports = __webpack_public_path__ + "static/img/file_scss.d247afe8.png";